import { useState, useEffect } from "react";
import axios from "axios";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { API } from "../config";

const DEFAULT_FAQ_DATA = {
  lv: [
    {
      q: "Cik izmaksā dzīvokļa remonts Latvijā?",
      a: "Izmaksas ļoti atšķiras atkarībā no darbu apjoma un materiālu izvēles. Aptuveni orientieri: Ātrais remonts (krāsošana, grīda) – €15–30/m²; Ekonomiskais remonts (špaktelēšana, grīda, pamata elektrika) – €80–120/m²; Premium remonts (pilnīga renovācija) – €200–300/m². Izmantojiet mūsu kalkulatoru precīzai aprēķināšanai."
    },
    {
      q: "Cik ilgs laiks aizņem dzīvokļa remonts?",
      a: "Laiks atkarīgs no platības un darbu sarežģītības: Ātrais remonts 40m² – 1–2 nedēļas; Pilnīgs remonts 50m² – 6–10 nedēļas; Premium remonts 80m² – 12–16 nedēļas. Kalkulatorā varat redzēt aptuvenā laika aprēķinu jūsu konkrētajam projektam."
    },
    {
      q: "Vai norādītās cenas ir ar PVN vai bez?",
      a: "Visas kalkulatorā norādītās cenas ir bez PVN (21%). Galīgajā rēķinā tiks piemērots PVN. Lūdzu ņemiet to vērā, veidojot budžetu."
    },
    {
      q: "Vai RMD strādā tikai Cēsīs vai arī citās Latvijas pilsētās?",
      a: "RMD bāzējas Cēsīs, taču pieņem pasūtījumus visā Latvijā. Lielākiem projektiem ārpus Cēsīm var tikt piemērotas papildu transporta izmaksas. Sazinieties ar mums, lai iegūtu precīzu informāciju par jūsu reģionu."
    },
    {
      q: "Ko ietver tāme, ko saņemu no kalkulatora?",
      a: "Tāme ietver darbu izmaksas (darbaspēks) pa kategorijām – Būvdarbi, Demolēšana, Noma. Materiālu cenas tiek iegūtas no WordPress veikala ar aktuālajiem Latvijas tirgus cenām. Tāme ir orientējoša – galīgā cena var atšķirties atkarībā no objekta specifika."
    },
    {
      q: "Vai varu saglabāt savu projektu un atgriezties vēlāk?",
      a: "Jā! Reģistrējoties un piesakoties lapā ar sava realmendo.com konta datiem, varat saglabāt neierobežotu skaitu projektu. Projekti saglabājas mākonī un ir pieejami no jebkuras ierīces."
    },
    {
      q: "Kāda ir garantija uz paveiktajiem darbiem?",
      a: "RMD sniedz garantiju uz visiem paveiktajiem darbiem. Garantijas termiņš atkarīgs no darbu veida: Konstruktīvie darbi – 5 gadi; Apdares darbi – 2 gadi; Elektrikas un santehnikas instalācija – 3 gadi. Visi darbi tiek dokumentēti aktos."
    },
    {
      q: "Vai materiālus nodrošina RMD, vai man tie jāiepērk pašam?",
      a: "Abas iespējas ir pieejamas. RMD var nodrošināt materiālu piegādi (tiek iekļauts % uzcenojums loģistikai). Alternatīvi, klients var iegādāties materiālus patstāvīgi pēc tāmes saraksta. Kalkulators palīdz salīdzināt cenas no Depo, K-Senukai un Kurši."
    },
    {
      q: "Kā notiek norēķins par darbiem?",
      a: "Standarta norēķinu kārtība: 30% avansa maksājums darbu sākumā; 40% pēc darbu vidus posma; 30% pēc objekta nodošanas. Precīzi nosacījumi tiek noteikti līgumā pirms darbu uzsākšanas."
    },
    {
      q: "Kā sazināties ar RMD?",
      a: "E-pasts: info@realmendo.com | WhatsApp: +371 25878923 | Mēs atbildam darba dienās 8:00–18:00. Ātrākai atbildei izmantojiet WhatsApp pogu lapas apakšējā labajā stūrī."
    },
    {
      q: "Vai varu saņemt bezmaksas konsultāciju?",
      a: "Jā! Pirmā konsultācija un objekta apskate ir bezmaksas. Sazinieties ar mums caur kontaktu veidlapu vai WhatsApp, un mēs vienosimies par piemērotu laiku."
    },
    {
      q: "Kādas maksājumu metodes tiek pieņemtas?",
      a: "RMD pieņem bankas pārskaitījumu, Paysera, kā arī skaidru naudu mazākiem darbiem. Rēķins tiek izrakstīts pēc katras darbu fāzes pabeigšanas."
    },
  ],
  ru: [
    {
      q: "Сколько стоит ремонт квартиры в Латвии?",
      a: "Стоимость сильно варьируется: Быстрый ремонт (покраска, пол) – €15–30/м²; Экономный ремонт (шпаклёвка, пол, базовая электрика) – €80–120/м²; Премиум ремонт (полная реновация) – €200–300/м². Используйте наш калькулятор для точного расчёта."
    },
    {
      q: "Сколько времени занимает ремонт квартиры?",
      a: "Быстрый ремонт 40м² – 1–2 недели; Полный ремонт 50м² – 6–10 недель; Премиум ремонт 80м² – 12–16 недель."
    },
    {
      q: "Цены указаны с НДС или без?",
      a: "Все цены в калькуляторе указаны без НДС (21%). НДС будет добавлен в итоговом счёте."
    },
    {
      q: "RMD работает только в Цесисе?",
      a: "RMD базируется в Цесисе, но принимает заказы по всей Латвии. Для крупных проектов за пределами Цесиса могут применяться дополнительные транспортные расходы."
    },
    {
      q: "Что включает смета из калькулятора?",
      a: "Смета включает стоимость работ по категориям. Цены на материалы берутся из WordPress-магазина с актуальными ценами. Смета ориентировочная."
    },
    {
      q: "Могу ли я сохранить проект?",
      a: "Да! После регистрации на сайте вы можете сохранять неограниченное количество проектов, доступных с любого устройства."
    },
    {
      q: "Какая гарантия на выполненные работы?",
      a: "Конструктивные работы – 5 лет; Отделочные работы – 2 года; Электрика и сантехника – 3 года."
    },
    {
      q: "Материалы предоставляет RMD или нужно купить самостоятельно?",
      a: "Возможны оба варианта. RMD может обеспечить поставку материалов или клиент покупает самостоятельно по списку сметы."
    },
    {
      q: "Как производится оплата?",
      a: "30% аванс при начале работ; 40% после средней фазы; 30% после сдачи объекта."
    },
    {
      q: "Как связаться с RMD?",
      a: "E-mail: info@realmendo.com | WhatsApp: +371 25878923 | Рабочие дни 8:00–18:00."
    },
    {
      q: "Возможна бесплатная консультация?",
      a: "Да! Первая консультация и осмотр объекта бесплатны. Свяжитесь с нами через форму или WhatsApp."
    },
    {
      q: "Какие способы оплаты принимаются?",
      a: "Банковский перевод, Paysera, наличные для небольших работ."
    },
  ],
  en: [
    {
      q: "How much does apartment renovation cost in Latvia?",
      a: "Costs vary widely: Quick renovation (painting, flooring) – €15–30/m²; Economy renovation – €80–120/m²; Premium renovation – €200–300/m². Use our calculator for a precise estimate."
    },
    {
      q: "How long does apartment renovation take?",
      a: "Quick renovation 40m² – 1–2 weeks; Full renovation 50m² – 6–10 weeks; Premium renovation 80m² – 12–16 weeks."
    },
    {
      q: "Are the prices VAT inclusive or exclusive?",
      a: "All prices in the calculator are exclusive of VAT (21%). VAT will be added to the final invoice."
    },
    {
      q: "Does RMD work only in Cēsis?",
      a: "RMD is based in Cēsis but accepts orders throughout Latvia. Additional transport costs may apply for projects outside Cēsis."
    },
    {
      q: "What does the calculator estimate include?",
      a: "The estimate includes labour costs by category. Material prices are pulled from the WordPress store with current Latvian market rates. The estimate is indicative."
    },
    {
      q: "Can I save my project?",
      a: "Yes! After registering, you can save unlimited projects accessible from any device."
    },
    {
      q: "What warranty is provided?",
      a: "Structural works – 5 years; Finishing works – 2 years; Electrical & plumbing – 3 years."
    },
    {
      q: "Are materials supplied by RMD or purchased separately?",
      a: "Both options are available. RMD can supply materials or the client can purchase independently following the estimate list."
    },
    {
      q: "How does payment work?",
      a: "30% advance at start; 40% after mid-phase; 30% after project handover."
    },
    {
      q: "How to contact RMD?",
      a: "Email: info@realmendo.com | WhatsApp: +371 25878923 | Mon–Fri 8:00–18:00."
    },
    {
      q: "Is a free consultation available?",
      a: "Yes! First consultation and site visit are free. Contact us via the contact form or WhatsApp."
    },
    {
      q: "What payment methods are accepted?",
      a: "Bank transfer, Paysera, cash for smaller works."
    },
  ],
};

function FAQItem({ q, a, isOpen, onToggle, idx }) {
  return (
    <div
      data-testid={`faq-item-${idx}`}
      className="border-b-2 border-black"
    >
      <button
        onClick={onToggle}
        className="w-full flex items-start justify-between gap-4 py-5 px-0 text-left hover:text-[#FF6600] transition-colors"
      >
        <span className="font-bold text-base pr-4" style={{ fontFamily: "Chivo, sans-serif" }}>
          {q}
        </span>
        <span className="flex-shrink-0 mt-0.5">
          {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </span>
      </button>
      {isOpen && (
        <div className="pb-5 text-sm text-gray-600 leading-relaxed border-l-4 border-[#FF6600] pl-4 ml-1">
          {a}
        </div>
      )}
    </div>
  );
}

export default function FAQPage() {
  const { lang } = useLanguage();
  const [openIdx, setOpenIdx] = useState(0);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch FAQ from API
    axios.get(`${API}/rmd/v1/faq`)
      .then(r => {
        if (r.data && r.data.length > 0) {
          setFaqs(r.data);
        } else {
          // Fallback to default data if API returns empty
          setFaqs(DEFAULT_FAQ_DATA[lang] || DEFAULT_FAQ_DATA.lv);
        }
      })
      .catch(() => {
        // Fallback to default data if API fails
        setFaqs(DEFAULT_FAQ_DATA[lang] || DEFAULT_FAQ_DATA.lv);
      })
      .finally(() => setLoading(false));
  }, [lang]);

  const titles = {
    lv: "BIEŽĀK UZDOTIE JAUTĀJUMI",
    ru: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
    en: "FREQUENTLY ASKED QUESTIONS",
  };
  const subtitles = {
    lv: "Atbildes uz biežākajiem jautājumiem par RMD pakalpojumiem un kalkulatoru.",
    ru: "Ответы на частые вопросы об услугах RMD и калькуляторе.",
    en: "Answers to common questions about RMD services and the calculator.",
  };
  const ctaLabels = {
    lv: "Aprēķināt izmaksas",
    ru: "Рассчитать стоимость",
    en: "Calculate Costs",
  };
  const contactLabels = {
    lv: "Jautājums nav atbildēts? Sazinieties ar mums",
    ru: "Нет ответа? Свяжитесь с нами",
    en: "Question not answered? Contact us",
  };

  return (
    <div style={{ paddingTop: 72 }} className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-black py-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <span className="rmd-label text-[#FF6600] block mb-3">FAQ</span>
          <h1
            className="text-white text-4xl md:text-6xl font-black uppercase tracking-tight leading-none"
            style={{ fontFamily: "Chivo, sans-serif" }}
            data-testid="faq-title"
          >
            {titles[lang] || titles.lv}
          </h1>
          <p className="text-white/50 mt-4 text-base max-w-xl">
            {subtitles[lang] || subtitles.lv}
          </p>
        </div>
      </section>

      {/* FAQ list */}
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        {loading ? (
          <div className="text-center py-8 text-gray-400">Ielāde...</div>
        ) : (
          <div className="border-t-2 border-black">
            {faqs.length > 0 ? (
              faqs.map((item, i) => (
                <FAQItem
                  key={i}
                  idx={i}
                  q={item.q || item.question}
                  a={item.a || item.answer}
                  isOpen={openIdx === i}
                  onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
                />
              ))
            ) : (
              <div className="text-center py-8 text-gray-400">Nav pieejami jautājumi</div>
            )}
          </div>
        )}

        {/* CTA */}
        <div className="mt-16 border-2 border-black p-8 bg-[#f9f9f9]" style={{ boxShadow: "4px 4px 0 #000" }}>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
            <div>
              <p className="font-black text-xl uppercase tracking-tight mb-1" style={{ fontFamily: "Chivo, sans-serif" }}>
                {contactLabels[lang] || contactLabels.lv}
              </p>
              <p className="text-sm text-gray-500">info@realmendo.com · +371 25878923</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/kalkulators" className="rmd-btn-primary text-sm">
                {ctaLabels[lang] || ctaLabels.lv} <ArrowRight size={14} />
              </Link>
              <Link to="/kontakti" className="rmd-btn-secondary text-sm">
                {lang === "ru" ? "Контакты" : lang === "en" ? "Contact" : "Kontakti"}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black py-8">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-white/30 text-xs">© {new Date().getFullYear()} RMD – Real Men Do · Cēsis, Latvija</p>
        </div>
      </footer>
    </div>
  );
}
